<template lang="pug">
div
	transition(name="fade")
		div(id="contieneAlerta" v-if="actual !== null")
			div
				div
					.card(style="min-width:300px;")
						.card-header(:class="actual.claseCabecera")
							|{{actual.titulo}}
						.card-body.bg-light.text-center(v-if="actual.tipo === 'error'")
							span.fa.fa-exclamation-triangle(style="font-size:3em;color:#BBBBBB;")
						.card-body.text-left(v-if="actual.mensaje" v-html="'<p>' +  actual.mensaje.replace(/\\n/g, '</p><p>') + '</p>'")
						.card-footer
							button.m-1(:class="b.clase" @click="cerrar(b.valor)" v-for="(b, index) of actual.buttons" :key="b.titulo" :ref="'boton-' + index")
								span(v-if="b.icono" :class="b.icono" style="margin-right: 3px;")
								|{{b.titulo}}
</template>


<script>

import {mapGetters} from 'vuex'

export default {
	name: 'alertas',

	data: function () {
		return {

		}
	},
	watch: {
		actual: function (newVal) {
			if (newVal) {
				window.setTimeout(() => {
					if (this.$refs['boton-0'].length > 0) {
						this.$refs['boton-0'][0].focus()
					}
				}, 100)
			}
		}
	},

	computed: {
		...mapGetters('alertas', ['actual'])
	},

	methods: {
		cerrar (payload) {
			if (this.actual.callback) {
				this.actual.callback(payload)
			}

			this.$store.commit('alertas/cerrar')
		}
	}
}
</script>


<style scoped>
	#contieneAlerta {
		position: fixed;
		display: block;
		background-color: rgba(0,0,0,0.4);
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 3000;
	}

	#contieneAlerta>div {
		position: relative;
		display: block;
		text-align: center;
	}

	#contieneAlerta>div>div {
		position: relative;
		display: inline-block;
		text-align: center;
		max-width: 500px;
		padding-top: 50px;
	}

	.fade-enter-active, .fade-leave-active {
		transition: all .3s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/common/alertas.vue